var _excluded = ["size", "fit", "position", "radius"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { styled, forwardRef } from '@grupoboticario/flora-react-system';
import { filterUndefined } from '@grupoboticario/flora-react-utils';
var StyledImage = styled('img', {
  verticalAlign: 'middle',
  maxWidth: '100%',
  height: 'auto'
});

/**
 * @component
 * @name Image
 * @description Image component
 * @tutorial https://flora.gb.tech/docs/components/core/image
 */
export var Image = forwardRef((_ref, forwardedRef) => {
  var {
    size,
    fit,
    position,
    radius
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var css = filterUndefined(_extends({
    size: !!isNaN(Number(size)) ? size : Number(size),
    objectFit: fit,
    objectPosition: position,
    borderRadius: radius
  }, props.css));
  return /*#__PURE__*/React.createElement(StyledImage, _extends({}, props, {
    "data-flora": "image",
    ref: forwardedRef,
    css: css
  }));
});
//# sourceMappingURL=Image.js.map